import { ActionTree, ActionContext } from "vuex";
import { RootState } from "@/store";

import { State } from "./state";
import { Mutations } from "./mutations";
import { AlertMutationTypes } from "./mutation-types";
import { AlertActionTypes } from "./action-types";
import api from "@/store/axiosAgsc";
import { GeneralMutationTypes } from "@/store/modules/general/mutation-types";

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, "commit">;

export interface Actions {
  [AlertActionTypes.GET_ALERTCONDITION_CATS](
    { commit }: AugmentedActionContext,
    payload: number // Obsolete in here but left as an example
  ): Promise<void>;
  [AlertActionTypes.GET_COMPANY_CONDITIONS](
      { commit }: AugmentedActionContext,
      payload: string // Obsolete in here but left as an example
  ): any;
  [AlertActionTypes.GET_ALARM_CONDITIONS](
      { commit }: AugmentedActionContext,
      payload: string // Obsolete in here but left as an example
  ): any;
  [AlertActionTypes.REMOVE_CONDITION](
    { commit }: AugmentedActionContext,
    payload: number // Obsolete in here but left as an example
  ): any;
  [AlertActionTypes.UPDATE_CONDITION](
    { commit }: AugmentedActionContext,
    payload: Array<any> // Obsolete in here but left as an example
  ): any;
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [AlertActionTypes.GET_ALERTCONDITION_CATS](
    { commit },
    category: number
  ) {
    return new Promise<void>((resolve) => {
      api
        .get(
          "Alarm/GetAlarmConditionCategories?conditionCategoryType=" + category,
          null
        )
        .then((response) => {
          commit(
            AlertMutationTypes.SET_ALERTCONDITION_CATS,
            response.data.entityData
          );
          resolve(response.data);
        });
    });
  },
  async [AlertActionTypes.GET_COMPANY_CONDITIONS](
      { commit },
      companyId: string
  ) {
    return new Promise<Array<any>>((resolve) => {
      api
          .get("Alarm/GetCompanyConditions?companyGuid=" + companyId, null)
          .then((response) => {
            resolve(response.data);
          });
    });
  },
  async [AlertActionTypes.GET_ALARM_CONDITIONS](
      { commit }
  ) {
    return new Promise<Array<any>>((resolve) => {
      api
          .get("Alarm/GetAlarmConditions", null)
          .then((response) => {
            resolve(response.data);
          });
    });
  },
  async [AlertActionTypes.REMOVE_CONDITION]({ commit }, conditionId: number) {
    return new Promise<Array<any>>((resolve) => {
      api
        .delete("Alarm/RemoveCondition?conditionId=" + conditionId)
        .then((response) => {
          resolve(response.data);
        });
    });
  },
  async [AlertActionTypes.UPDATE_CONDITION]({ commit }, data) {
    return new Promise<any>((resolve) => {
      api.post("Alarm/UpdateCondition", data).then((response) => {
        resolve(response.data);
      });
    });
  },
};
